import { useState, useEffect, useRef } from "react";
import cn from "classnames";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "next-i18next";
import s from './ShareButtons.module.scss'
import i from "@styles/icons.module.scss";


const ShareButtons = () => {
    const { t } = useTranslation(["common"]);
    const facebookShareButton = useRef(null);
    const twitterShareButton = useRef(null);

    const [copyLink, setCopyLink] = useState({
        link: "",
        show: false,
    });

    const onCopy = () => {
        setCopyLink((prev) => ({ ...prev, show: true }));
    };

    useEffect(() => {
        // if (typeof window !== "undefined") {
        setCopyLink((prev) => ({ ...prev, link: window.location.href }));
        // }
    }, []);

    useEffect(() => {
        if (facebookShareButton.current) {
            facebookShareButton.current.addEventListener("click", function () {
                const url = window.location.href;
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                    "facebook",
                    "width=800,height=600"
                );
                return false;
            });
        }

        if (twitterShareButton.current) {
            twitterShareButton.current.addEventListener("click", function () {
                const hashTags = `luxexpress,estonia`;
                const url = window.location.href;
                const text = "Lux Express - the most comfortable seat on highways";


                window.open(
                    `https://twitter.com/share?url=${url}&text=${text}&hashtags=${hashTags}`,
                    // `https://twitter.com/share?url=${url}`,
                    "twitter",
                    "width=800,height=600"
                );


                return false;
            });
        }
    }, []);


    return (
        <div className={s.links}>
            <div
                ref={facebookShareButton}
                className={s.link}
                id="fb-share-button"
                data-href={copyLink.link}
            >
                <icon className={i.facebook} />
            </div>
            <CopyToClipboard onCopy={onCopy} text={copyLink.link}>
                <div className={s.link} onClick={copyLink}>
                    <icon className={i.link} />
                </div>
            </CopyToClipboard>
            <div
                ref={twitterShareButton}
                className={s.link}
                id="twitter-share-button"
            >
                <icon className={i.twitter} />
            </div>
            <div
                onAnimationEnd={() =>
                    setCopyLink((prev) => ({ ...prev, show: false }))
                }
                className={cn(s.copied, copyLink.show && s.animate)}
            >
                {t("copied")}
            </div>
        </div>
    )
}

export default ShareButtons